<template>
  <div
    class="bg-surface-default-mid border-static-default-mid rounded-md flex w-full items-center justify-center border p-16 text-center"
  >
    <span class="text-static-default-low body-2"
      >{{ i18n(translations.cardPlaceholder) }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from './ProductComparisonCardPlaceholder.translations'

const i18n = useI18n()
</script>
